import { marqueeItems } from "@/data/portfolio";

export const Marquee = () => {
  const row = [...marqueeItems, ...marqueeItems];
  return (
    <div
      className="marquee-hover relative overflow-hidden border-y border-white/5 bg-[#0D0E15]/60 py-6"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display text-2xl font-bold tracking-wide sm:text-3xl ${
                i % 2 === 0 ? "text-outline" : "text-slate-200"
              }`}
            >
              {item}
            </span>
            <span className="mx-8 font-mono text-cyan-400">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
